export const ticket550 =  () => {
    return `<?xml version="1.0" encoding="utf-8"?>
    <DieCutLabel Version="8.0" Units="twips" MediaType="Default">
      <PaperOrientation>Landscape</PaperOrientation>
      <Id>LargeLeverArch99019</Id>
      <PaperName>99019 Large Lever Arch</PaperName>
      <DrawCommands>
        <Rectangle X="0" Y="0" Width="3329" Height="10771"/>
      </DrawCommands>
      <ObjectInfo>
        <TextObject>
          <Name>CLIENTNAME</Name>
          <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
          <BackColor Alpha="0" Red="255" Green="255" Blue="255"/>
          <LinkedObjectName></LinkedObjectName>
          <Rotation>Rotation0</Rotation>
          <IsMirrored>False</IsMirrored>
          <IsVariable>False</IsVariable>
          <HorizontalAlignment>Center</HorizontalAlignment>
          <VerticalAlignment>Top</VerticalAlignment>
          <TextFitMode>None</TextFitMode>
          <UseFullFontHeight>True</UseFullFontHeight>
          <Verticalized>False</Verticalized>
          <StyledText>
            <Element>
              <String>CLIENTNAME</String>
              <Attributes>
                <Font Family="Arial" Size="9" Bold="False" Italic="False" Underline="False" Strikeout="False"/>
                <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
              </Attributes>
            </Element>
          </StyledText>
        </TextObject>
        <Bounds X="50" Y="243.9008" Width="8640" Height="184.9011"/>
      </ObjectInfo>
      <ObjectInfo>
        <TextObject>
          <Name>EVENTNAME1</Name>
          <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
          <BackColor Alpha="0" Red="255" Green="255" Blue="255"/>
          <LinkedObjectName></LinkedObjectName>
          <Rotation>Rotation0</Rotation>
          <IsMirrored>False</IsMirrored>
          <IsVariable>False</IsVariable>
          <HorizontalAlignment>Center</HorizontalAlignment>
          <VerticalAlignment>Middle</VerticalAlignment>
          <TextFitMode>AlwaysFit</TextFitMode>
          <UseFullFontHeight>True</UseFullFontHeight>
          <Verticalized>False</Verticalized>
          <StyledText>
            <Element>
              <String>EVENTNAME1</String>
              <Attributes>
                <Font Family="Arial" Size="18" Bold="True" Italic="False" Underline="False" Strikeout="False"/>
                <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
              </Attributes>
            </Element>
          </StyledText>
        </TextObject>
        <Bounds X="50" Y="360" Width="8640" Height="1008"/>
      </ObjectInfo>
      <ObjectInfo>
        <TextObject>
          <Name>EVENTDATETIME</Name>
          <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
          <BackColor Alpha="0" Red="255" Green="255" Blue="255"/>
          <LinkedObjectName></LinkedObjectName>
          <Rotation>Rotation0</Rotation>
          <IsMirrored>False</IsMirrored>
          <IsVariable>False</IsVariable>
          <HorizontalAlignment>Center</HorizontalAlignment>
          <VerticalAlignment>Top</VerticalAlignment>
          <TextFitMode>None</TextFitMode>
          <UseFullFontHeight>True</UseFullFontHeight>
          <Verticalized>False</Verticalized>
          <StyledText>
            <Element>
              <String>EVENTDATETIME</String>
              <Attributes>
                <Font Family="Arial" Size="11" Bold="True" Italic="False" Underline="False" Strikeout="False"/>
                <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
              </Attributes>
            </Element>
          </StyledText>
        </TextObject>
        <Bounds X="50" Y="1312.81" Width="8640" Height="288"/>
      </ObjectInfo>
      <ObjectInfo>
        <TextObject>
          <Name>VENUENAME</Name>
          <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
          <BackColor Alpha="0" Red="255" Green="255" Blue="255"/>
          <LinkedObjectName></LinkedObjectName>
          <Rotation>Rotation0</Rotation>
          <IsMirrored>False</IsMirrored>
          <IsVariable>False</IsVariable>
          <HorizontalAlignment>Center</HorizontalAlignment>
          <VerticalAlignment>Top</VerticalAlignment>
          <TextFitMode>None</TextFitMode>
          <UseFullFontHeight>True</UseFullFontHeight>
          <Verticalized>False</Verticalized>
          <StyledText>
            <Element>
              <String>VENUENAME</String>
              <Attributes>
                <Font Family="Arial" Size="9" Bold="False" Italic="False" Underline="False" Strikeout="False"/>
                <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
              </Attributes>
            </Element>
          </StyledText>
        </TextObject>
        <Bounds X="50" Y="1588.544" Width="8640" Height="432"/>
      </ObjectInfo>
      <ObjectInfo>
        <TextObject>
          <Name>VENUEADDRESS</Name>
          <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
          <BackColor Alpha="0" Red="255" Green="255" Blue="255"/>
          <LinkedObjectName></LinkedObjectName>
          <Rotation>Rotation0</Rotation>
          <IsMirrored>False</IsMirrored>
          <IsVariable>False</IsVariable>
          <HorizontalAlignment>Center</HorizontalAlignment>
          <VerticalAlignment>Top</VerticalAlignment>
          <TextFitMode>None</TextFitMode>
          <UseFullFontHeight>True</UseFullFontHeight>
          <Verticalized>False</Verticalized>
          <StyledText>
            <Element>
              <String>VENUEADDRESS</String>
              <Attributes>
                <Font Family="Arial" Size="9" Bold="False" Italic="False" Underline="False" Strikeout="False"/>
                <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
              </Attributes>
            </Element>
          </StyledText>
        </TextObject>
        <Bounds X="50" Y="1788.786" Width="8640" Height="537.8085"/>
      </ObjectInfo>
      <ObjectInfo>
        <TextObject>
          <Name>EVENTEXPLANATION</Name>
          <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
          <BackColor Alpha="0" Red="255" Green="255" Blue="255"/>
          <LinkedObjectName></LinkedObjectName>
          <Rotation>Rotation0</Rotation>
          <IsMirrored>False</IsMirrored>
          <IsVariable>False</IsVariable>
          <HorizontalAlignment>Center</HorizontalAlignment>
          <VerticalAlignment>Top</VerticalAlignment>
          <TextFitMode>None</TextFitMode>
          <UseFullFontHeight>True</UseFullFontHeight>
          <Verticalized>False</Verticalized>
          <StyledText>
            <Element>
              <String>EVENTEXPLANATION</String>
              <Attributes>
                <Font Family="Arial" Size="9" Bold="False" Italic="False" Underline="False" Strikeout="False"/>
                <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
              </Attributes>
            </Element>
          </StyledText>
        </TextObject>
        <Bounds X="50" Y="1788.786" Width="8640" Height="537.8085"/>
      </ObjectInfo>
      <ObjectInfo>
        <TextObject>
          <Name>EVENTSECTION</Name>
          <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
          <BackColor Alpha="0" Red="255" Green="255" Blue="255"/>
          <LinkedObjectName></LinkedObjectName>
          <Rotation>Rotation0</Rotation>
          <IsMirrored>False</IsMirrored>
          <IsVariable>False</IsVariable>
          <HorizontalAlignment>Center</HorizontalAlignment>
          <VerticalAlignment>Top</VerticalAlignment>
          <TextFitMode>None</TextFitMode>
          <UseFullFontHeight>True</UseFullFontHeight>
          <Verticalized>False</Verticalized>
          <StyledText>
            <Element>
              <String>EVENTSECTION</String>
              <Attributes>
                <Font Family="Arial" Size="18" Bold="True" Italic="False" Underline="False" Strikeout="False"/>
                <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
              </Attributes>
            </Element>
          </StyledText>
        </TextObject>
        <Bounds X="50" Y="2001.785" Width="8640" Height="537.8085"/>
      </ObjectInfo>
      <ObjectInfo>
        <TextObject>
          <Name>EVENTEXPLANATION2</Name>
          <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
          <BackColor Alpha="0" Red="255" Green="255" Blue="255"/>
          <LinkedObjectName></LinkedObjectName>
          <Rotation>Rotation0</Rotation>
          <IsMirrored>False</IsMirrored>
          <IsVariable>False</IsVariable>
          <HorizontalAlignment>Center</HorizontalAlignment>
          <VerticalAlignment>Top</VerticalAlignment>
          <TextFitMode>None</TextFitMode>
          <UseFullFontHeight>True</UseFullFontHeight>
          <Verticalized>False</Verticalized>
          <StyledText>
            <Element>
              <String>EVENTEXPLANATION2</String>
              <Attributes>
                <Font Family="Arial" Size="9" Bold="False" Italic="False" Underline="False" Strikeout="False"/>
                <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
              </Attributes>
            </Element>
          </StyledText>
        </TextObject>
        <Bounds X="50" Y="2001.785" Width="8640" Height="537.8085"/>
      </ObjectInfo>
      <ObjectInfo>
        <TextObject>
          <Name>EVENTROWSEAT</Name>
          <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
          <BackColor Alpha="0" Red="255" Green="255" Blue="255"/>
          <LinkedObjectName></LinkedObjectName>
          <Rotation>Rotation0</Rotation>
          <IsMirrored>False</IsMirrored>
          <IsVariable>False</IsVariable>
          <HorizontalAlignment>Center</HorizontalAlignment>
          <VerticalAlignment>Top</VerticalAlignment>
          <TextFitMode>None</TextFitMode>
          <UseFullFontHeight>True</UseFullFontHeight>
          <Verticalized>False</Verticalized>
          <StyledText>
            <Element>
              <String>EVENTROWSEAT</String>
              <Attributes>
                <Font Family="Arial" Size="18" Bold="True" Italic="False" Underline="False" Strikeout="False"/>
                <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
              </Attributes>
            </Element>
          </StyledText>
        </TextObject>
        <Bounds X="50" Y="2317.495" Width="8640" Height="432"/>
      </ObjectInfo>
      <ObjectInfo>
        <TextObject>
          <Name>EVENTEXPLANATION3</Name>
          <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
          <BackColor Alpha="0" Red="255" Green="255" Blue="255"/>
          <LinkedObjectName></LinkedObjectName>
          <Rotation>Rotation0</Rotation>
          <IsMirrored>False</IsMirrored>
          <IsVariable>False</IsVariable>
          <HorizontalAlignment>Center</HorizontalAlignment>
          <VerticalAlignment>Top</VerticalAlignment>
          <TextFitMode>None</TextFitMode>
          <UseFullFontHeight>True</UseFullFontHeight>
          <Verticalized>False</Verticalized>
          <StyledText>
            <Element>
              <String>EVENTEXPLANATION3</String>
              <Attributes>
                <Font Family="Arial" Size="9" Bold="False" Italic="False" Underline="False" Strikeout="False"/>
                <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
              </Attributes>
            </Element>
          </StyledText>
        </TextObject>
        <Bounds X="50" Y="2317.495" Width="8640" Height="432"/>
      </ObjectInfo>
      <ObjectInfo>
        <TextObject>
          <Name>PRICE</Name>
          <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
          <BackColor Alpha="0" Red="255" Green="255" Blue="255"/>
          <LinkedObjectName></LinkedObjectName>
          <Rotation>Rotation0</Rotation>
          <IsMirrored>False</IsMirrored>
          <IsVariable>False</IsVariable>
          <HorizontalAlignment>Center</HorizontalAlignment>
          <VerticalAlignment>Top</VerticalAlignment>
          <TextFitMode>None</TextFitMode>
          <UseFullFontHeight>True</UseFullFontHeight>
          <Verticalized>False</Verticalized>
          <StyledText>
            <Element>
              <String>PRICE</String>
              <Attributes>
                <Font Family="Arial" Size="11" Bold="True" Italic="False" Underline="False" Strikeout="False"/>
                <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
              </Attributes>
            </Element>
          </StyledText>
        </TextObject>
        <Bounds X="50" Y="2678.585" Width="8640" Height="288"/>
      </ObjectInfo>
      <ObjectInfo>
        <TextObject>
          <Name>EVENTORDERINFO</Name>
          <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
          <BackColor Alpha="0" Red="255" Green="255" Blue="255"/>
          <LinkedObjectName></LinkedObjectName>
          <Rotation>Rotation0</Rotation>
          <IsMirrored>False</IsMirrored>
          <IsVariable>False</IsVariable>
          <HorizontalAlignment>Left</HorizontalAlignment>
          <VerticalAlignment>Top</VerticalAlignment>
          <TextFitMode>None</TextFitMode>
          <UseFullFontHeight>True</UseFullFontHeight>
          <Verticalized>False</Verticalized>
          <StyledText>
            <Element>
              <String>EVENTORDERINFO</String>
              <Attributes>
                <Font Family="Arial" Size="11" Bold="True" Italic="False" Underline="False" Strikeout="False"/>
                <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
              </Attributes>
            </Element>
          </StyledText>
        </TextObject>
        <Bounds X="6336" Y="2906.953" Width="3960" Height="279.2891"/>
      </ObjectInfo>
      <ObjectInfo>
        <ImageObject>
          <Name>BARCODE</Name>
          <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
          <BackColor Alpha="0" Red="255" Green="255" Blue="255"/>
          <LinkedObjectName />
          <Rotation>Rotation270</Rotation>
          <IsMirrored>False</IsMirrored>
          <IsVariable>False</IsVariable>
          <Image>iVBORw0KGgoAAAANSUhEUgAAAHQAAAB0CAYAAABUmhYnAAAEiklEQVR4Xu2dQY7jMAwEk/8/OgPsaS0DLjRI2YpSe6UkU11synY2mffn8/m8/LeNAm+BbsPy30YEuhdPgW7GU6AC3U2BzfbjGSrQzRTYbDs6VKCbKbDZdnSoQDdTYLPt6FCBbqbAZtvRoQLdTIHNtlN26Pv9vlWS7o9vx/zH9b9tfwIdClKgOrS1Q1U7kA7VoceCpDOoWr7V9Wl+Nf70/sbrtzu02jJOCYKDSNAqMJpP16d49/oCDVvuagWrQ4f/tUoOoTg5kOLd6093aPocR48NFCcBaX413n19Wu92hwr0KHlaMAIFBVJBqSXOLliBCrT23ZanK3i2Q57enw7VoTr0/xqonrHkqHR9Ws+73Obn0NktX6CpAsP41EECnXzGFXm+BBq+CyXBZwv69PXT/VG+P3+GkkCp4D/XcklAilefA+nTkXR9Wo/2c3JU8ePB2x2abjDdMDmEAAh0UJwEEei1At36Tf/4TKBfDrQKkOZXb1qq8ym/apyOCFq/3aF0wWq8CqQ6v5o/zRdo+BwsUCgpusukikzjVSDV+Wm+6fjHHZom3D2e7hLTgqsK2r2/dL3yGZpesHu8QI+KCnSoMB3abblwPR3a7NBuQYknOYjOzKdviih/2j/Fyy1XoCTxMS7Q8IzTocWS0aGbOTTbzuuVOojWp4Lqnt99vTG/or/u/wFkgV7/yIhAi5/4p45Lx48O7C7o0/p3/1WI7g11C0wO6b7e8i2XgNGZRs+JqQCUD12vCpgKgOKk13SHkoCUIAks0GsFyy8W0jNCoMc/ZKVDH37RQAVMHSaNkwGmt1xKgFoynVndglK+dL10Po1P9y/Q2rcn8cUIAaO4QIv/p4gE1qGgkC33WqDHHZoCSu/qusfTehRPHTv7Jqj9DBVo9m42LZj4SKi++hOoQA9FR2dGWtE0vhrfvuWmLaF7PAFKAVB+VIA0f3a8/dXf7IQJEAlORwTlT+vT/NlxgYYKCzQULB1uyz0qVnZotYWlAMkhlE/6XJiul+6ne7xAw1eHIwAqsG5gtJ5ABTr07MX+EE/aIukMTtcjB82Otzu0uwV1C06ASPC790f5TH+Xe/eGCRDdBKWC3b2/ND8dGiom0FCw9E2QDp38HFptcTT/7ni1wLodTf6Y3nLJQfRcl94UdQMXKPwEOFVYN5BqQQhUoIcasOU2/8g/dQRycOrQ6njKl+Lbn6EoQPh1xNkFQPlSXKACvX6XSzc1VGE0P43T9WY7Ll2f8qX49g6lx6ZqgRAwihOgNC7Q8CYsvekRaCgwCaZDQ49XBb37TVH1ej/v0LA+TsOpYFKBu/NJC4TGl/Pr/ipE95sRgWaIp98UZemcRws0U1CgmV74DW56DPq6lhvqEw8nwajlk+Mpnp7Z6XqxIMOEdodWE6L5Ar1WSKDhc68OJcuFcR062aEhD4dPVqDccifn5/KhAgINBVt9uEBXJxTmJ9BQsNWHC3R1QmF+Ag0FW324QFcnFOYn0FCw1YcLdHVCYX4CDQVbfbhAVycU5ifQULDVhwt0dUJhfgINBVt9uEBXJxTm9wcuqGMOjAKAbAAAAABJRU5ErkJggg==</Image>
          <ScaleMode>Uniform</ScaleMode>
          <BorderWidth>0</BorderWidth>
          <BorderColor Alpha="255" Red="0" Green="0" Blue="0"/>
          <HorizontalAlignment>Center</HorizontalAlignment>
          <VerticalAlignment>Center</VerticalAlignment>
        </ImageObject>
        <Bounds X="8004" Y="1440" Width="864" Height="864"/>
      </ObjectInfo>
      <ObjectInfo>
        <ShapeObject>
          <Name>Shape</Name>
          <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
          <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
          <LinkedObjectName></LinkedObjectName>
          <Rotation>Rotation0</Rotation>
          <IsMirrored>False</IsMirrored>
          <IsVariable>False</IsVariable>
          <ShapeType>Line</ShapeType>
          <LineWidth>45</LineWidth>
          <LineAlignment>Center</LineAlignment>
          <FillColor Alpha="0" Red="255" Green="255" Blue="255" />
        </ShapeObject>
        <Bounds X="8400" Y="50" Width="8640" Height="3329"/>
      </ObjectInfo>
    </DieCutLabel>`
}



// WEBPACK FOOTER //
// ./src/lib/labels/ShowTix4UTicket550.js